import React, { useState } from "react";
import T from "prop-types";
import { Map } from "immutable";

import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import ConfirmAction from "MODULES/shared/components/ConfirmAction/ConfirmAction";
import {
  APPROVED,
  REJECTED,
  TRACE_HOLD
} from "MODULES/PurchaseOrders/constants";

export default function SetTraceHold({
  purchaseOrder,
  onConfirm,
  traceApproved
}) {
  const [confirmationIsVisible, setConfirmationVisibility] = useState(false);

  if (
    !purchaseOrder.get(TRACE_HOLD) &&
    !purchaseOrder.get(REJECTED) &&
    !purchaseOrder.get(APPROVED)
  ) {
    return false;
  }

  const type = traceApproved ? "Approve" : "Reject";
  const icon = traceApproved ? "check" : "ban";

  return (
    <DropDownItem onClick={() => setConfirmationVisibility(true)}>
      <Icon name={icon} fixed />
      &nbsp;{type} Trace
      <ConfirmAction
        onConfirm={onConfirm}
        close={() => setConfirmationVisibility(false)}
        open={confirmationIsVisible}
        btnClass="btn-danger"
        btnText={`Yes, ${type} Trace`}
        cancelText="Cancel"
        icon={<i className={`fa fa-fw fa-${icon}`} />}
      >
        <strong>Heads up!</strong>
        &nbsp; Are you sure you want to {type} Trace for this PO?
      </ConfirmAction>
    </DropDownItem>
  );
}

SetTraceHold.propTypes = {
  onConfirm: T.func.isRequired,
  purchaseOrder: T.instanceOf(Map).isRequired,
  traceApproved: T.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/SetTraceHold/SetTraceHold.jsx